// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviewRecord__container-e87d3b {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  padding: 0 16px 0 8px;
  width: 100%;
}

.PreviewRecord__timer-fc3e04 {
  margin-inline-start: 12px;
  color: var(--base-80);
  font-size: var(--font-smaller-size);
}

.PreviewRecord__histogram-cb1403 {
  flex: 1 1;
  height: 24px;
  margin-inline-start: 8px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/RecordingSection/PreviewRecord/PreviewRecord.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,qBAAA;EACA,mCAAA;AACF;;AAEA;EACE,SAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 16px 0 8px;\n  width: 100%;\n}\n\n.timer {\n  margin-inline-start: 12px;\n  color: var(--base-80);\n  font-size: var(--font-smaller-size);\n}\n\n.histogram {\n  flex: 1 1;\n  height: 24px;\n  margin-inline-start: 8px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PreviewRecord__container-e87d3b`,
	"timer": `PreviewRecord__timer-fc3e04`,
	"histogram": `PreviewRecord__histogram-cb1403`
};
module.exports = ___CSS_LOADER_EXPORT___;
